module.exports = "/_next/static/images/platforms_mobile-f09855750c0e77dfa932bd36003f592e.png";